<template>
  <div class="height-percent-1000">
    <Layout style="padding-top: 6px;padding-left: 6px;height: 100%;">
      <Header class="layout-header-bar">
        <img @click="onLeftMenuClick" class="menu-button-style"
             src="../../assets/common/ic_fenlei_dark.png"
             v-if="showShortMenu">
        <img :src="getEntLogo" style="margin-right: 55px;width: 60px;height: 60px"/>
        <span class="fz-30 font-bold " style="color: #333333">{{ title }}</span>
        <div style="flex-grow: 1;"></div>
        <div class="flex-row title_style color-white">
          <div @click="gotoUserEdit" class="user-cover">
            <img :src="getuserpath" alt class="user_cover_img">
          </div>
          <div @click="gotoUserEdit" class="user-info">
            <p class="fz-18 color-33" style="font-weight: bold;cursor: pointer">{{ getusername }}</p>
          </div>
        </div>
        <!--<div style="width: 1px;height: 20px;background-color: #DEDEDE;margin: 0 20px"-->
        <!--v-if="getcompanynum>1"></div>-->
        <!--<div @click="onCompanyChoose" class="flex-row" style="cursor: pointer" v-if="getcompanynum>1">-->
        <!--<img src="../../assets/common/ic_qiehuanzhanghao@2x.png" style="width: 30px;height: 32px">-->
        <!--<p class="color-33 fz-18" style="font-weight: bold;margin-left:10px;">切换企业</p>-->
        <!--</div>-->
        <div style="width: 1px;height: 20px;background-color: #DEDEDE;margin: 0 20px"></div>
        <div @click="logout" class="flex-row">
          <!--<img src="../../assets/common/ic_header_quit.png" style="width: 27px;height: 25px">-->
          <span
            style="height: 29px;line-height:29px;margin-left:10px;font-size: 18px;font-weight: bold;color: #3B80FF">退出</span>
        </div>
      </Header>
      <slot>
        <Layout style="margin-bottom: 5px;height: 100%;overflow: hidden">
          <Sider :collapsed-width="78" class="ld-sider-style noscroll" collapsible hide-trigger
                 ref="sider" style="overflow: scroll "
                 width="160">
            <sider-content :menuList="menuList" @onSideMenuClick="_onSideMenuClick"></sider-content>
          </Sider>
          <Content :class="{'blact-style':showblackcolor}" class="content-style">
            <div class="tag-nav-wrapper height-40">
              <tags-nav
                :list="tagNavList"
                :value="$route" @input="handleClick" @on-close="handleCloseTag"
                class="h-full" ref="tagsNav"/>
            </div>
            <!--keep-alive 表示页面不会被销毁，即保持页面状态-->
            <keep-alive :include="cacheList">
              <router-view class="w-full o-hidden" style="height: calc(100% - 1px)"
              ></router-view>
            </keep-alive>
          </Content>
        </Layout>
      </slot>
    </Layout>
    <Modal class-name="vertical-center-modal"
           footer-hide
           v-model="showUserEdit"
           width="600">
      <user-edit :showinfo="showUserEdit" @userconfig="showUserEdit =false"/>
    </Modal>

    <Drawer :closable="false" :width="160" placement="left" v-if="showShortMenu"
            v-model="showleftmenu">
      <div style="width: 160px;height: 100%;background-color: #243D54;overflow: hidden">
        <div class="flex-column h-70">
          <img @click="onBackClick" alt="" class="w-30 h-30"
               src="../../assets/common/ic_fanhui.png">
        </div>
        <sider-content :menuList="menuList" @onSideMenuClick="_onSideMenuClick"></sider-content>
      </div>
    </Drawer>
  </div>
</template>

<script>
import SiderContent from './SiderContent'
import UserEdit from '../user/UserEdit'
import tagsNav from '@/components/common/tags-nav'
import {getNewTagList, routeEqual} from '@/libs/util'
import {mapMutations} from 'vuex'
import routers from '@/router/router'
import {getLoginAppInfo} from '../../utils/util'

export default {
  name: 'PlatFormPage',
  components: {
    UserEdit,
    SiderContent,
    tagsNav
  },
  props: {
    menuList: Array,
    title: String,
    showShortMenu: {
      type: Boolean,
      default: true
    }
  },
  watch: {
    '$route' (newRoute) {
      const {name, query, params, meta} = newRoute

      let currentTag = this.$refs.tagsNav.value

      let index = -1
      for (let i = 0; i < this.tagNavList.length; i++) {
        if (routeEqual(this.tagNavList[i], currentTag)) {
          index = i
          break
        }
      }
      if (index < 0) {
        index = this.tagNavList.length - 1
      }
      this.addTag({
        route: {name, query, params, meta},
        type: 'push',
        index: index + 1,
      })
      this.setBreadCrumb(newRoute)
      this.setTagNavList(getNewTagList(this.tagNavList, newRoute))
      //zgh:::没用..
      // this.$refs.sideMenu.updateOpenName(newRoute.name)
    }
  },
  data () {
    return {
      showUserEdit: false,
      showblackcolor: false,
      showleftmenu: false
    }
  },
  mounted () {
    /**
     * @description 初始化设置面包屑导航和标签导航
     */
    this.setTagNavList()
    this.setHomeRoute(routers)
    const {name, params, query, meta} = this.$route
    this.addTag({
      route: {name, params, query, meta}
    })

    // Bus.$on('onhomemounted', () => {
    //   this.showblackcolor = true
    // })
    // Bus.$on('onhomedestroyed', () => {
    //   this.showblackcolor = false
    // })
    // if (this.$route.path === '/bootpage') {
    //   this.showblackcolor = true
    // }
  },
  destroyed () {
    // Bus.$off('onhomemounted')
    // Bus.$off('onhomedestroyed')
  },
  computed: {
    getuserpath () {
      return this.$store.state.user.avatarImgPath || require('../../assets/common/icon_portrait_default.png')
    },
    getusername () {
      return this.$store.state.user.userName || '老刀号'
    },
    getcompanynum () {
      return this.$store.state.user.entCount || 2
    },
    tagNavList () {
      return this.$store.state.app.tagNavList
    },
    cacheList () {
      const list = [...this.tagNavList.length ? this.tagNavList.filter(item => !(item.meta && item.meta.notCache)).map(item => item.name) : []]
      return list
    },
    getEntLogo () {
      return this.$store.state.company.entLogo || require('../../assets/common/icon_logo.png')
    }
  },
  methods: {
    onBackClick () {
      this.showleftmenu = false
    },
    onLeftMenuClick () {
      this.showleftmenu = true
    },
    onCompanyChoose () {
      this.$router.replace('/switchcompany')
    },
    gotoUserEdit () {
      // this.showUserEdit = true
      this.$router.push({
        path: '/personcenter',
        query: {
          type: 1
        }
      })
    },
    _onSideMenuClick (item) {
      this.$emit('onSideMenuClick', item)
      if (this.showleftmenu) {
        this.showleftmenu = false
      }
    },
    logout () {
      if (this.tagNavList) {
        let res = this.tagNavList.filter(item => item.name === this.$config.homeName)
        if (res) {
          this.setTagNavList(res)
        }
      }
      this.$store.dispatch('handleLogOut')
      let info = getLoginAppInfo()
      if (info && info.pathEnt) {
        this.$router.replace({path: '/ldh/ent/' + info.pathEnt})
      } else {
        this.$router.replace('/login')
      }

    },
    // tagNavList () {
    //   return this.$store.state.app.tagNavList
    //   // return [{"name":"bootpage","params":{},"query":{},"meta":{"hideInMenu":false,"title":"首页","notCache":true,"icon":"md-home"},"path":"/bootpage"},{"name":"iconrepository","query":{},"params":{},"meta":{"icon":"ios-document","title":"图标库"},"path":"/iconrepository"},{"name":"examplerepository","query":{},"params":{},"meta":{"icon":"md-clipboard","title":"案例库"},"path":"/examplerepository"}]
    // },
    handleCloseTag (res, type, route) {
      if (type !== 'others') {
        if (type === 'all') {
          this.turnToPage('HomePageList')
        } else {
          if (routeEqual(this.$route, route)) {
            this.closeTag(route)
          }
        }
      }
      this.setTagNavList(res)
    },

    turnToPage (route) {
      let {name, params, query} = {}
      if (typeof route === 'string') name = route
      else {
        name = route.name
        params = route.params
        query = route.query
      }
      if (name.indexOf('isTurnByHref_') > -1) {
        window.open(name.split('_')[1])
        return
      }
      this.$router.push({
        name,
        params,
        query
      })
    },
    handleClick (item) {
      this.turnToPage(item)
    },
    ...mapMutations([
      'setBreadCrumb',
      'setTagNavList',
      'addTag',
      'setLocal',
      'setHomeRoute',
      'closeTag'
    ]),
  }
}
</script>

<style lang="scss" scoped>

  .height-percent-1000 {
    width: 100%;
    height: 100%;
    overflow: hidden;
  }

  .layout-header-bar {
    display: flex;
    justify-content: flex-start;
    align-items: center;
    min-width: 1014px;
    z-index: 99;
    line-height: 72px;
    /*background: url("../../assets/common/ic_header_bg.png");*/
    background-color: white;
    border-right: 10px solid #f5f7f9;
    box-sizing: border-box;
    box-shadow: 0px 0px 8px 0px rgba(1, 0, 52, 0.12);
  }

  .content-style {
    margin: 10px 10px 10px 10px;
    height: 100%;
    background-color: white;
    overflow: hidden;
  }

  .blact-style {
    margin: 0 10px 0 0 !important;
    background-color: #4A4A4A !important;
  }

  .title_style {
    height: 100%;

    .user-cover {
      width: 40px;
      height: 40px;
      border-radius: 50%;
      text-align: center;

      .user_cover_img {
        width: 40px;
        height: 40px;
        border-radius: 50%;
      }
    }

    .user-info {
      margin-left: 20px;
    }
  }

  .ld-sider-style {
    z-index: 99;
    background-color: #243D54;
    display: block;
  }

  @media (max-width: 1204px) {
    .ld-sider-style {
      display: none;
    }
  }

  .menu-button-style {
    display: none;
  }

  @media (max-width: 1204px) {
    .menu-button-style {
      width: 36px;
      height: 36px;
      margin-right: 30px;
      display: block;
    }
  }

  div ::v-deep .ivu-drawer-body {
    padding: 0;
  }
</style>

<style>
  .tags-nav .btn-con.left-btn {
    left: -5px;
  }

  .tags-nav .scroll-outer {
    left: 20px;
    right: 0;
    box-shadow: 0 0 0 0 rgba(0, 0, 0, 0);
  }
</style>
